import { useState } from "react";
import { useDebounce } from "use-debounce";
import useSearchBooks from "./api-request/useSearchBooks";

const useSearch = (initialFormat = "PDF") => {
  const [searchQuery, setSearchQuery] = useState("");
  const [format, setFormat] = useState(initialFormat);
  const [debouncedQuery] = useDebounce(searchQuery, 300);

  // Use a single hook and pass the format parameter
  const {
    data: searchResults,
    isLoading: loading,
    error,
  } = useSearchBooks(debouncedQuery, format);

  return {
    searchQuery,
    setSearchQuery,
    format,
    setFormat,
    results: searchResults?.results || [],
    loading,
    error,
  };
};

export default useSearch;
